import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { layoutChartDialogComponent } from '../../../../private-dashboard/layout-chart-dialog/layout-chart-dialog';
import { CommonService } from '../../../services';
let HotSpot = require('../../../../../assets/lib/jquery_hotspot.js');
declare let $: any;

@Component({
    selector: 'static-layout-map',
    templateUrl: './static-layout-map.component.html',
    styleUrls: ['./static-layout-map.component.css']
})

export class StaticLayoutMapComponent implements OnInit, AfterViewInit, OnChanges {
    @ViewChild('layoutImage') layoutImage: ElementRef;
    @Input('graphData') graphData: any;
    @Input('widget') widget: any;
    @Input('showEdit') showEdit: boolean;
    image: any;
    hotSpots = {};
    spotId: number = 0;
    layoutBoxValue = {};
    options: any;

    constructor(public layoutdialog: MatDialog, private commonService: CommonService) { }

    ngOnChanges(changes: SimpleChanges): void { }

    ngOnInit(): void {
        let dataFilter = this.widget.dataFilter;
        let graphData = this.graphData.dataFilter;

        setTimeout(() => {
            for (let i = 0; i < dataFilter.length; i++) {
                let df = dataFilter[i];
                this.options = {
                    x: df.pageX,
                    y: df.pageY,
                    image: this.image,
                    pointerColor: df.pointerColor ? df.pointerColor : "#DC143C",
                    transparency: df.transparency ? df.transparency : 1,
                    labelColor: df.labelColor ? df.labelColor : "#ffffff",
                    tooltipPosition: df.tooltipPosition ? df.tooltipPosition : "top",
                    label: graphData.length > 0 && graphData[i] && graphData[i].label ? graphData[i].label.split('::').pop() : "",
                    value: graphData.length > 0 && graphData[i] && graphData[i].data.length > 0 ? graphData[i].data[0].value : 0,
                    backGroundColor: df.backGroundColor,
                    borderColor: df.borderColor,
                    spotId: Number(df.id),
                    layoutId: this.widget._id
                }
                if (graphData.length > 0 && graphData[i] && graphData[i].data.length > 0 && df.kpiNumberFormat != "") {
                    if (df.kpiNumberFormat == "-1") {
                        this.options['value'] = this.commonService.shortNumberFormat(graphData[i].data[0].value);
                    }else{
                        graphData[i].data[0].value = !graphData[i].data[0].value ? 0.00 : parseFloat(graphData[i].data[0].value);
                        this.options['value'] = graphData[i].data[0].value.toFixed(df.kpiNumberFormat);
                    }
                }
                if (graphData.length > 0 && graphData[i] && graphData[i].data.length > 0 && df.isThousandSeperator) {
                    this.options['value'] = this.commonService.formatNumberString(this.options['value'], true);
                }
                let hotSpot = new HotSpot.HotSpot(this.options);
                hotSpot.init();
                this.hotSpots[hotSpot.id] = hotSpot;
                this.spotId = Number(hotSpot.id) + 1;
            }
        }, 900)
    }

    ngAfterViewInit(): void {
        this.image = this.layoutImage.nativeElement;
    }

    onClickHotsPost = (event: any) => {
        if (!this.showEdit) {
            return
        }
        event.preventDefault();
        // event.stopImmediatePropagation();
        let height = $(this.image).height(), width = $(this.image).width();
        let relativeToImageTop = event.offsetY;
        let relativeToImageLeft = event.offsetX;
        relativeToImageLeft = relativeToImageLeft / width * 100;
        relativeToImageTop = relativeToImageTop / height * 100;
        if ($(event.target).hasClass('t_hotSpot')) {
            let id = $(event.target).attr('id').replace('t_hotspot_' + this.widget._id + '_', '')
            this.hotSpots[id].select();
            this.updatePointer(event, id)
        }
        else {
            HotSpot.selectedSpot ? HotSpot.selectedSpot.deselect() : null;
            this.createPointer(relativeToImageLeft, relativeToImageTop)
        }
    };

    createPointer(x: number, y: number) {
        const dialogRef = this.layoutdialog.open(layoutChartDialogComponent, {
            height: "auto",
            width: "800px",
            panelClass: "full-modal",
            data: { widgetData: this.widget, pageX: Number(x.toFixed(2)), pageY: Number(y.toFixed(2)), id: this.spotId, isCreate: true }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result == undefined || result == '') {
                return false
            }
        });
    }

    updatePointer(event: any, id = -1) {
        const dialogRef = this.layoutdialog.open(layoutChartDialogComponent, {
            height: "auto",
            width: "800px",
            panelClass: "full-modal",
            data: { widgetData: this.widget, pageX: event.pageX, pageY: event.pageY, id: id, isCreate: false }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result == undefined || result == '') {
                HotSpot.selectedSpot ? HotSpot.selectedSpot.deselect({}) : null;
            }
        });
    }
}


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/static-layout-map/static-layout-map.component.ts